import { apiFetch } from "./api";

export const saveMetrics = async (values, quarterly, meetingDate) => {
    const obj = {
        method: 'POST',
        body: {
            metrics: values,
            option: 'save_edit_metrics',
            quarterly: quarterly,
            meeting_date: meetingDate
        }
    }

    const response = await apiFetch(obj);

    return response;
};
